export const userGZA= 'diariodopara';
export const passwordGZA ='dpa2020';
